<template>
    <div class="orders-history-card">
      <img src="/images/promo/connect-features/orders-history-card.svg" alt="Orders history card" />
    </div>
</template>

<script>
export default {};
</script>
